// NPC diyalog ekranı için hafif canvas parçacık sistemi.

export default class NpcFx {
  constructor(canvas) {
    this.cv = canvas;
    this.c = canvas.getContext('2d');
    this.p = [];
    this.kind = null;
    this.run = false;
    this.w = 0;
    this.h = 0;
    this.loop = this.loop.bind(this);
  }

  size() {
    const r = this.cv.getBoundingClientRect();
    const d = Math.min(window.devicePixelRatio || 1, 2);
    this.w = r.width;
    this.h = r.height;
    this.cv.width = Math.max(1, r.width * d);
    this.cv.height = Math.max(1, r.height * d);
    this.c.setTransform(d, 0, 0, d, 0, 0);
  }

  start(kind) {
    this.kind = kind;
    this.size();
    if (!this.run) {
      this.run = true;
      this.raf = requestAnimationFrame(this.loop);
    }
  }

  stop() {
    this.run = false;
    cancelAnimationFrame(this.raf);
    this.p = [];
    if (this.w) this.c.clearRect(0, 0, this.w, this.h);
  }

  add(o) {
    if (this.p.length < 450) this.p.push(o);
  }

  /** x, y oran (0-1) olarak verilir. */
  burst(rx, ry, n, k) {
    const x = rx * this.w;
    const y = ry * this.h;
    for (let i = 0; i < n; i++) {
      const a = Math.random() * Math.PI * 2;
      const s = k === 'spark' ? 2 + Math.random() * 7 : 0.8 + Math.random() * 3;
      const vy = k === 'spark' ? -Math.abs(Math.sin(a) * s) - 1 : Math.sin(a) * s;
      this.add({ x, y, vx: Math.cos(a) * s, vy, l: 0, m: k === 'spark' ? 30 + Math.random() * 30 : 60 + Math.random() * 60, r: 1 + Math.random() * 2.4, k });
    }
  }

  ambient() {
    const { kind: k, w, h } = this;
    if (!w) return;
    const R = Math.random;
    if ((k === 'spark' || k === 'ember') && R() < (k === 'spark' ? 0.5 : 0.3)) {
      this.add({ x: w * (0.25 + R() * 0.5), y: h * (0.85 + R() * 0.1), vx: (R() - 0.5) * 0.6, vy: -0.6 - R() * 1.3, l: 0, m: 90 + R() * 80, r: 1 + R() * 1.8, k: 'ember' });
    }
    if (k === 'gold' && R() < 0.18) this.add({ x: R() * w, y: R() * h * 0.8, vx: 0, vy: 0.15, l: 0, m: 70 + R() * 50, r: 1.5 + R() * 2, k: 'gold' });
    if (k === 'dust' && R() < 0.3) this.add({ x: R() * w, y: h * (0.3 + R() * 0.7), vx: (R() - 0.5) * 0.3, vy: -0.15 - R() * 0.3, l: 0, m: 160 + R() * 120, r: 0.8 + R() * 1.8, k: 'dust' });
    if (k === 'leaf' && R() < 0.12) this.add({ x: R() * w, y: -10, vx: 0.3 + R() * 0.6, vy: 0.5 + R() * 0.6, l: 0, m: 260, r: 3 + R() * 3, k: 'leaf', rot: R() * 6 });
    if (k === 'water' && R() < 0.2) this.add({ x: R() * w, y: h + 5, vx: 0, vy: -0.5 - R() * 0.8, l: 0, m: 220, r: 1.5 + R() * 3.5, k: 'water' });
  }

  loop() {
    if (!this.run) return;
    const c = this.c;
    c.clearRect(0, 0, this.w, this.h);
    this.ambient();
    for (let i = this.p.length - 1; i >= 0; i--) {
      const p = this.p[i];
      p.l++;
      if (p.k === 'spark') { p.vy += 0.25; p.vx *= 0.98; }
      else if (p.k === 'ember') p.vx += (Math.random() - 0.5) * 0.08;
      else if (p.k === 'gold') { p.vx *= 0.96; p.vy = p.vy * 0.96 + 0.03; }
      else if (p.k === 'dust') p.vx += (Math.random() - 0.5) * 0.03;
      else if (p.k === 'leaf') { p.vx = Math.sin(p.l * 0.04) * 0.9 + 0.3; p.rot += 0.04; }
      else if (p.k === 'water') p.vx = Math.sin(p.l * 0.08) * 0.4;
      p.x += p.vx;
      p.y += p.vy;
      const t = 1 - p.l / p.m;
      if (t <= 0) { this.p.splice(i, 1); continue; }
      if (p.k === 'spark') {
        c.globalCompositeOperation = 'lighter';
        c.strokeStyle = `rgba(255,${(150 + Math.random() * 80) | 0},60,${t})`;
        c.lineWidth = p.r;
        c.beginPath(); c.moveTo(p.x, p.y); c.lineTo(p.x - p.vx * 3, p.y - p.vy * 3); c.stroke();
      } else if (p.k === 'leaf') {
        c.globalCompositeOperation = 'source-over';
        c.save(); c.translate(p.x, p.y); c.rotate(p.rot);
        c.fillStyle = `rgba(120,170,80,${Math.min(1, t * 1.5) * 0.85})`;
        c.beginPath(); c.ellipse(0, 0, p.r * 1.6, p.r * 0.7, 0, 0, 7); c.fill(); c.restore();
      } else if (p.k === 'water') {
        c.globalCompositeOperation = 'lighter';
        c.strokeStyle = `rgba(150,200,240,${t * 0.6})`;
        c.lineWidth = 1;
        c.beginPath(); c.arc(p.x, p.y, p.r, 0, 7); c.stroke();
      } else {
        c.globalCompositeOperation = 'lighter';
        const col = p.k === 'ember' ? `255,${(110 + Math.random() * 60) | 0},40` : p.k === 'gold' ? '255,214,120' : '220,200,170';
        const tw = p.k === 'gold' ? 0.5 + 0.5 * Math.sin(p.l * 0.3) : 1;
        c.fillStyle = `rgba(${col},${t * tw * (p.k === 'dust' ? 0.5 : 1)})`;
        c.beginPath(); c.arc(p.x, p.y, p.r, 0, 7); c.fill();
        if (p.k === 'gold' && tw > 0.8) {
          c.fillRect(p.x - p.r * 3, p.y - 0.5, p.r * 6, 1);
          c.fillRect(p.x - 0.5, p.y - p.r * 3, 1, p.r * 6);
        }
      }
    }
    c.globalCompositeOperation = 'source-over';
    this.raf = requestAnimationFrame(this.loop);
  }
}
